/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ENTRY_TEST — the knowledge test on the first day, which checks what someone brings from their current role. STAGE_TEST — the test that closes a stage of a training path. THEORY_EXAM and PRACTICAL_EXAM — the two parts of an exam. The first three take only questions worth one point, of the types the system scores by itself; a practical exam takes any.
 * @export
 * @enum {string}
 */

export const TestPurposeDto = {
    EntryTest: 'ENTRY_TEST',
    StageTest: 'STAGE_TEST',
    TheoryExam: 'THEORY_EXAM',
    PracticalExam: 'PRACTICAL_EXAM'
} as const;

export type TestPurposeDto = typeof TestPurposeDto[keyof typeof TestPurposeDto];



